import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardForClassProgramComponent } from './card-for-class-program/card-for-class-program.component';
import { CardForInstructorComponent } from './card-for-instructor/card-for-instructor.component';
import { CardScheduleComponent } from './card-schedule/card-schedule.component';
import { LiveStreamCardComponent } from './live-stream-card/live-stream-card.component';
import { NgbRatingModule} from '@ng-bootstrap/ng-bootstrap';
import { UserDashboardService } from '../services/user-dashboard.service'
import { DefaultImageDirective } from '../directive/default-image.directive';
import { ModalPopUpComponent } from '../modal-pop-up/modal-pop-up.component';
import { SubscribeNewsletterComponent } from './subscribe-newsletter/subscribe-newsletter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TravelCardComponent } from './travel-card/travel-card.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { NewsletterNewComponent } from './newsletter-new/newsletter-new.component';

@NgModule({
  declarations: [
    CardForClassProgramComponent,
    CardForInstructorComponent,
    CardScheduleComponent,
    LiveStreamCardComponent,
    DefaultImageDirective,
    ModalPopUpComponent,
    SubscribeNewsletterComponent,
    TravelCardComponent,
    ProductCardComponent,
    NewsletterNewComponent,
  ],
  imports: [
    CommonModule,
    NgbRatingModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports:[
    CardForClassProgramComponent,
    CardForInstructorComponent,
    CardScheduleComponent,
    LiveStreamCardComponent,
    DefaultImageDirective,
    ModalPopUpComponent,
    SubscribeNewsletterComponent,
    TravelCardComponent,
    ProductCardComponent,
    NewsletterNewComponent
  ],
  providers: [
    UserDashboardService
  ]
})
export class SharedModule { }
